import Vue from 'vue'
import Router from 'vue-router'

import Register from '@/components/Register'
import Login from '@/components/Login'
import LoginTimeout from '@/components/LoginTimeout'

import Home from '@/components/Home'
import HomeLoggedIn from '@/components/HomeLoggedIn'

import LoginUser from '@/components/LoginUser'
import LoginUserProfile from '@/components/LoginUserProfile'
import LoginUserNew from '@/components/LoginUserNew'
import LoginUserEdit from '@/components/LoginUserEdit'

import CustomerAccountList from '@/components/CustomerAccount/CustomerAccountList'
import CustomerAccountListInactive from '@/components/CustomerAccount/CustomerAccountListInactive'
import CustomerAccountNew from '@/components/CustomerAccount/CustomerAccountNew'
import CustomerAccountEdit from '@/components/CustomerAccount/CustomerAccountEdit'

import CareGroupList from '@/components/CareGroup/CareGroupList'
import CareGroupListInactive from '@/components/CareGroup/CareGroupListInactive'
import CareGroupNew from '@/components/CareGroup/CareGroupNew'
import CareGroupEdit from '@/components/CareGroup/CareGroupEdit'

import CareUserList from '@/components/CareUser/CareUserList'
import CareUserListInactive from '@/components/CareUser/CareUserListInactive'
import CareUserNew from '@/components/CareUser/CareUserNew'
import CareUserEdit from '@/components/CareUser/CareUserEdit'

import DeviceList from '@/components/Device/DeviceList'
import DeviceListInactive from '@/components/Device/DeviceListInactive'
import DeviceNew from '@/components/Device/DeviceNew'
import DeviceEdit from '@/components/Device/DeviceEdit'

import ContactUs from '@/components/ContactUs'
import AboutGreyguard from '@/components/AboutGreyguard'

import Alert from '@/components/Alert'
import Dashboard from '@/components/Dashboard'
import Admin from '@/components/Admin'

import RolePermission from '@/components/SystemAdmin/RolePermission'
import PermissionRole from '@/components/SystemAdmin/PermissionRole'
import RoleEdit from '@/components/SystemAdmin/RoleEdit'
import Reports from '@/components/SystemAdmin/Reports'

import TestLayout from '@/components/DeveloperTesting/TestLayout'
import TestLayout2 from '@/components/DeveloperTesting/TestLayout2'
import JWT from '@/components/DeveloperTesting/JWT'
import Test403 from '@/components/DeveloperTesting/Test403'

import AuthGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/homeLoggedIn',
      name: 'homeLoggedIn',
      component: HomeLoggedIn,
      beforeEnter: AuthGuard
    },
    {
      path: '/loginUser',
      name: 'loginUser',
      component: LoginUser,
      beforeEnter: AuthGuard
    },
    {
      path: '/loginUserProfile',
      name: 'loginUserProfile',
      component: LoginUserProfile,
      beforeEnter: AuthGuard
    },
    {
      path: '/loginUserNew',
      name: 'loginUserNew',
      component: LoginUserNew,
      beforeEnter: AuthGuard
    },
    {
      path: '/loginUserEdit',
      name: 'loginUserEdit',
      component: LoginUserEdit,
      beforeEnter: AuthGuard
    },
    {
      path: '/customerAccount',
      name: 'customerAccountList',
      component: CustomerAccountList,
      beforeEnter: AuthGuard
    },
    {
      path: '/customerAccountInactive',
      name: 'customerAccountListInactive',
      component: CustomerAccountListInactive,
      beforeEnter: AuthGuard
    },
    {
      path: '/customerAccountNew',
      name: 'customerAccountNew',
      component: CustomerAccountNew,
      beforeEnter: AuthGuard
    },
    {
      path: '/customerAccountEdit',
      name: 'customerAccountEdit',
      component: CustomerAccountEdit,
      beforeEnter: AuthGuard
    },
    {
      path: '/careGroup',
      name: 'careGroupList',
      component: CareGroupList,
      beforeEnter: AuthGuard
    },
    {
      path: '/careGroupInactive',
      name: 'careGroupListInactive',
      component: CareGroupListInactive,
      beforeEnter: AuthGuard
    },
    {
      path: '/careGroupNew',
      name: 'careGroupNew',
      component: CareGroupNew,
      beforeEnter: AuthGuard
    },
    {
      path: '/careGroupEdit',
      name: 'careGroupEdit',
      component: CareGroupEdit,
      beforeEnter: AuthGuard
    },
    {
      path: '/careUser',
      name: 'careUserList',
      component: CareUserList,
      beforeEnter: AuthGuard
    },
    {
      path: '/careUserInactive',
      name: 'careUserListInactive',
      component: CareUserListInactive,
      beforeEnter: AuthGuard
    },
    {
      path: '/careUserNew',
      name: 'careUserNew',
      component: CareUserNew,
      beforeEnter: AuthGuard
    },
    {
      path: '/careUserEdit',
      name: 'careUserEdit',
      component: CareUserEdit,
      beforeEnter: AuthGuard
    },
    {
      path: '/device',
      name: 'deviceList',
      component: DeviceList,
      beforeEnter: AuthGuard
    },
    {
      path: '/deviceInactive',
      name: 'deviceListInactive',
      component: DeviceListInactive,
      beforeEnter: AuthGuard
    },
    {
      path: '/deviceNew',
      name: 'deviceNew',
      component: DeviceNew,
      beforeEnter: AuthGuard
    },
    {
      path: '/deviceEdit',
      name: 'deviceEdit',
      component: DeviceEdit,
      beforeEnter: AuthGuard
    },
    {
      path: '/alert',
      name: 'alert',
      component: Alert,
      beforeEnter: AuthGuard
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: AuthGuard
    },
    {
      path: '/rolePermission',
      name: 'rolePermission',
      component: RolePermission,
      beforeEnter: AuthGuard
    },
    {
      path: '/permissionRole',
      name: 'permissionRole',
      component: PermissionRole,
      beforeEnter: AuthGuard
    },
    {
      path: '/roleEdit',
      name: 'roleEdit',
      component: RoleEdit,
      beforeEnter: AuthGuard
    },
    {
      path: '/roleAdd',
      name: 'roleAdd',
      component: Admin,
      beforeEnter: AuthGuard
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      beforeEnter: AuthGuard
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: ContactUs
    },
    {
      path: '/aboutGreyguard',
      name: 'aboutGreyguard',
      component: AboutGreyguard
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/loginTimeout',
      name: 'loginTimeout',
      component: LoginTimeout
    },
    {
      path: '/testLayout',
      name: 'testLayout',
      component: TestLayout,
      beforeEnter: AuthGuard
    },
    {
      path: '/testLayout2',
      name: 'testLayout2',
      component: TestLayout2,
      beforeEnter: AuthGuard
    },
    {
      path: '/jwt',
      name: 'jwt',
      component: JWT
    },
    {
      path: '/test403',
      name: 'test403',
      component: Test403
    },
    {
      path: '*',
      redirect: 'home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js